import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["ariaLabel", "classes", "field", "fieldValue", "id", "label", "message", "rounded", "mode", "terms"];
import React, { Fragment, useEffect } from 'react';
import { node, shape, string, bool } from 'prop-types';
import { Checkbox as InformedCheckbox, useFieldApi } from 'informed';
import useFieldState from '@magento/peregrine/lib/hooks/hook-wrappers/useInformedFieldStateWrapper';
import { Link } from 'react-router-dom';
import defaultClasses from './checkbox.module.css';
import { Message } from '../Field';
import CheckIcon from '../../Common/Icons/checkIcon';
import { useMergeCssClasses } from '../../../Utils/utils';
/* TODO: change lint config to use `label-has-associated-control` */

/* eslint-disable jsx-a11y/label-has-for */

var Checkbox = function Checkbox(_ref) {
  var ariaLabel = _ref.ariaLabel,
      propClasses = _ref.classes,
      field = _ref.field,
      fieldValue = _ref.fieldValue,
      id = _ref.id,
      label = _ref.label,
      message = _ref.message,
      rounded = _ref.rounded,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'light' : _ref$mode,
      _ref$terms = _ref.terms,
      terms = _ref$terms === void 0 ? false : _ref$terms,
      rest = _objectWithoutProperties(_ref, _excluded);

  var fieldApi = useFieldApi(field);
  var fieldState = useFieldState(field);
  var classes = useMergeCssClasses(defaultClasses, propClasses);
  var icon = fieldState.value && React.createElement(CheckIcon, null);
  var roundedClass = fieldState.value ? classes.inputRounded_active : classes.inputRounded;
  var inputClasses = fieldState.value ? classes.input_active : classes.input;
  var iconClasses = rounded ? classes.roundedIcon : classes.icon;
  var labelClasses = classes.label;

  if (mode == 'dark') {
    roundedClass = fieldState.value ? classes.inputRounded_active : classes.inputRounded;
    inputClasses = fieldState.value ? classes.input_active : classes.input_dark;
    iconClasses = rounded ? classes.roundedIcon : classes.icon_dark;
    labelClasses = classes.label_dark;
  }

  useEffect(function () {
    if (fieldValue != null && fieldValue !== fieldState.value) {
      fieldApi.setValue(fieldValue);
    }
  }, [fieldApi, fieldState.value, fieldValue]);
  return React.createElement(Fragment, null, React.createElement("label", {
    "aria-label": ariaLabel,
    className: classes.root,
    htmlFor: id
  }, React.createElement(InformedCheckbox, _extends({}, rest, {
    className: rounded ? roundedClass : inputClasses,
    field: field,
    id: id
  })), React.createElement("span", {
    className: iconClasses
  }, icon), terms ? React.createElement(Link, {
    target: "_blank",
    to: "/terms-and-conditions",
    className: labelClasses,
    "aria-label": "Go to Terms and Conditions page"
  }, "I have read The ", React.createElement("span", {
    className: "underline"
  }, "Terms and Conditions")) : React.createElement("span", {
    className: labelClasses
  }, label)), React.createElement(Message, {
    fieldState: fieldState
  }, message));
};

export default Checkbox;
Checkbox.propTypes = {
  ariaLabel: string,
  classes: shape({
    icon: string,
    input: string,
    label: string,
    message: string,
    root: string
  }),
  field: string.isRequired,
  id: string,
  label: node.isRequired,
  message: node,
  rounded: bool
};
/* eslint-enable jsx-a11y/label-has-for */